import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Organization, OrganizationProjects, OrganizationUsers, Project, ProjectUsers } from '@models';

export interface WorkspaceLoadPayload {
  projects: Project[];
  organizations: Organization[];
  orgProjects: OrganizationProjects[];
  projectUsers: ProjectUsers[];
  orgUsers: OrganizationUsers[];
}

export const WorkspaceActions = createActionGroup({
  source: 'Workspace',
  events: {
    Init: emptyProps(),
    Reload: emptyProps(),
    'Load Started': emptyProps(),
    Reset: emptyProps(),
    'Selection Restored': props<{ projectId: string | null; organizationId: string | null }>(),
    'Select Project': props<{ projectId: string | null; organizationId?: string | null }>(),
    'Load Succeeded': props<WorkspaceLoadPayload>(),
    'Load Failed': props<{ error: string }>(),
    // Optimistic merge of entities just created client-side, so the workspace
    // doesn't depend on read-after-write consistency of a full reload.
    'Entities Upserted': props<{ entities: Partial<WorkspaceLoadPayload> }>(),
    'Entities Removed': props<{ entities: Partial<WorkspaceLoadPayload> }>(),
  },
});
